/* Elite Edge Nutrition — header offset measurement.
   The full-height hero must fill the viewport below everything above it:
   announcement bar + header. Dawn's own --header-height is set once, before
   the logo image has loaded, so it reads ~40px short and never counts the
   announcement bar at all — that combination pushed the hero's scroll cue
   below the fold. Measure the whole header group for real, keep both custom
   properties current via ResizeObserver (fires again when the logo image
   lands), and let the CSS fallbacks carry the no-JS case. */
(function () {
  var doc = document;
  var ro = null;

  function apply() {
    var sections = doc.querySelectorAll('.shopify-section-group-header-group');
    if (!sections.length) return;
    var total = 0;
    for (var i = 0; i < sections.length; i++) total += sections[i].offsetHeight;
    var root = doc.documentElement.style;
    root.setProperty('--ee-header-offset', total + 'px');
    var header = doc.querySelector('.section-header');
    if (header) root.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function watch() {
    apply();
    if (!('ResizeObserver' in window)) return;
    if (ro) ro.disconnect();
    ro = new ResizeObserver(apply);
    var sections = doc.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < sections.length; i++) ro.observe(sections[i]);
  }

  watch();
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  // The theme editor swaps header-group DOM nodes in place; re-attach.
  doc.addEventListener('shopify:section:load', watch);
})();

/* Elite Edge Nutrition — scroll-reveal animations.
   Elements with .ee-reveal fade + rise into view as they enter the viewport.
   Safe by default: if this script never runs, nothing is hidden (the hiding
   styles only apply once .ee-anim-ready is added to <body>). */
(function () {
  var doc = document;
  var body = doc.body;
  if (!body) return;

  // Respect reduced-motion: leave everything visible, no animation.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var els = [].slice.call(doc.querySelectorAll('.ee-reveal'));
  if (!els.length) return;

  // Turn on the hiding styles only now that JS is committed to revealing them.
  body.classList.add('ee-anim-ready');

  // In the theme editor, reveal immediately so editing stays usable.
  if (window.Shopify && window.Shopify.designMode) {
    els.forEach(function (el) { el.classList.add('ee-in'); });
    return;
  }

  // Stagger siblings that share a parent for a cascading effect.
  var groups = new Map();
  els.forEach(function (el) {
    var p = el.parentElement;
    var arr = groups.get(p) || [];
    arr.push(el);
    groups.set(p, arr);
  });
  groups.forEach(function (arr) {
    arr.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
    });
  });

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ee-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ee-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el) { io.observe(el); });
})();
